/**
 * Read every row of a list query, one page at a time.
 *
 * PostgREST caps each response at the project's max_rows (1000), whatever
 * .limit() asks for, so one request silently drops everything past the cap.
 * Pages until one comes back empty rather than short, so a cap smaller than
 * pageSize still reads everything. The query must have a unique order (end it
 * with id) or rows can repeat or go missing between pages.
 */
export async function readAllRows<T>(
  page: (from: number, to: number) => PromiseLike<{ data: T[] | null; error: unknown }>,
  pageSize = 1000,
): Promise<T[]> {
  const rows: T[] = [];
  // TODO(ceiling): 20k rows client-side; move to server-side search/paging past that.
  for (;;) {
    const { data, error } = await page(rows.length, rows.length + pageSize - 1);
    if (error) throw error;
    if (!data || data.length === 0) return rows;
    rows.push(...data);
    if (rows.length > 20000) throw new Error("readAllRows: more than 20000 rows");
  }
}
